export default __webpack_public_path__ + "static/media/top-vector-tip.1d917002.svg";